import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { EventBus } from "../views/event-bus";
// AXIOS 설정, API서버 주소 셋팅
export const http = axios.create({
  baseURL: '/backend', // 첫 번째 인스턴스의 기본 URL 설정
});

export const elasticHttp = axios.create({
  baseURL: '/elasticApi', // 첫 번째 인스턴스의 기본 URL 설정
});
// axios.defaults.baseURL = '/backend';
// axios.defaults.elasticURL = '/elastic'

Vue.prototype.$http = http;
Vue.prototype.$http1 = elasticHttp;
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    credential: {
      clientName: 'my-trusted-client',
      clientSecret: 'secret',
    },
    accessToken: null,
    userInfo: {}, // 유저 정보 추가
    server: {
      // API서버 주소 셋팅
      api_domain: "/backend",
      // api_domain : "http://127.0.0.1:9200",
    },
    historyStates: true,
  },
  getters: {
    getUserInfo: function (state) {
      return state.userInfo;
    },
    getAPIDomain: function (state) {
      return state.server.api_domain;
    },
    getCredentialCode: function (state) {
      return 'Basic ' + btoa(state.credential.clientName + ':' + state.credential.clientSecret)
    },
    getHistoryStates: function (state) {
      return state.historyStates;
    },
    isAuthenticated: state => !!state.accessToken,
    getToken: state => state.accessToken,

  },

  mutations: {
    SET_HISTORY_STATES(state, val) {
      state.historyStates = val;
    },
    LOGIN(state, payload) {
      // 토큰 저장
      if (payload.token && payload.token.access_token) {
        state.accessToken = payload.token.access_token;
      }
      // 유저 정보 저장
      if (payload.user) {
        state.userInfo = payload.user;
      }
    },
    LOGOUT(state) {
      state.accessToken = null;
      state.userInfo = {};
    },
    // 새로고침 시 세션 스토리지 등에서 정보 복구용
    RESTORE_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },

    // 토큰만 복구
    RESTORE_TOKEN(state, token) {
      state.accessToken = token;
    }
  },
  actions: {
    LOGIN({ commit }, payload) {
      // payload expects { token: {...}, user: {...} }
      if (payload.token && payload.token.access_token) {
        sessionStorage.setItem("myToken", payload.token.access_token);
        // 토큰 만료 시간도 저장 (선택사항)
        if (payload.token.expires_in) {
          const expiryTime = Date.now() + (payload.token.expires_in * 1000);
          sessionStorage.setItem("tokenExpiry", expiryTime);
        }
      }
      commit('LOGIN', payload);
    },
    LOGOUT({ commit }) {
      commit('LOGOUT');
      // sessionStorage 완전히 삭제
      sessionStorage.removeItem("myToken");
      sessionStorage.removeItem("tokenExpiry");
      sessionStorage.removeItem("userInfo"); // 만약 userInfo도 저장했다면
    },

    // 페이지 새로고침 시 세션 복구
    RESTORE_SESSION({ commit }) {
      const token = sessionStorage.getItem("myToken");
      const tokenExpiry = sessionStorage.getItem("tokenExpiry");

      // 토큰이 있고 만료되지 않았으면 복구
      if (token && token !== "null") {
        if (!tokenExpiry || Date.now() < parseInt(tokenExpiry)) {
          commit('RESTORE_TOKEN', token);
          // userInfo도 복구 (필요시)
          // const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
          // commit('RESTORE_USER_INFO', userInfo);
        } else {
          // 토큰 만료됨
          sessionStorage.removeItem("myToken");
          sessionStorage.removeItem("tokenExpiry");
        }
      }
    },

    // 관리자 메뉴 노출 여부 체크
    ACCESSCHK({ commit }, self) {
      var token = sessionStorage.getItem("myToken");
      const manager_id = self.$session.get("userInfo").manager_id;

      self.$http.get('/api/select/getAccessMenu?access_token=' + token + '&manager_id=' + manager_id)
        .then((result) => {

          const menuInfo = result.data.access_menu;
          const access_menu_arr = menuInfo ? menuInfo.split(',') : [''];

          self.nav.forEach(function (value, key) {
            // 접근 허용된 메뉴들 노출
            if (value.code != '' && access_menu_arr.includes(value.code)) {
              value.active_yn = 'Y';
              // 공통 이외의 메뉴 미노출
            } else if (value.code != 'common') {
              value.active_yn = 'N';
            }
          });
        })
    },

    // qna 문의 넘버링 노출용 이벤트 버스
    QNATOTALCNT({ commit }, self) {
      var token = sessionStorage.getItem("myToken");
      self.$http.get('/api/select/qnaNewCnt?access_token=' + token)
        .then((result) => {
          // new 노출용
          EventBus.$emit('showQnaNew', parseInt(result.data));
          // 문의 카운트 노출용
          EventBus.$emit('changeQnaCnt', parseInt(result.data));
        })
    },

    ORDERTOTALCNT({ commit }, self) {
      var token = sessionStorage.getItem("myToken");
      self.$http.get('/api/select/orderNewCnt?access_token=' + token + '&ordertype=all')
        .then((result) => {
          console.log(parseInt(result.data));
          if (parseInt(result.data) > 0) {
            $('.neworderflag').show();
          } else {
            $('.neworderflag').hide();
          }
          self.$store.dispatch('ORDERNEWCNT', self); // 이승훈
        })
    },
    ORDERNEWCNT({ commit }, self) {
      // 주문관리 새로운 건있는지 확인.
      var token = sessionStorage.getItem("myToken");
      var rpOrderCntHtml;
      var apOrderCntHtml;
      $('.nav-dropdown-items').find('.nav-item').find('.nav-link').each(function (index, item) {

        if ($(item).attr('href') == '#/order/product') {
          rpOrderCntHtml = $(item).find('i');
          self.$http.get('/api/select/orderNewCnt?access_token=' + token + '&ordertype=RP')
            .then((result) => {
              EventBus.$emit('changeRpCnt', parseInt(result.data));
              /*
              var rpCnt = parseInt(result.data);
              if(rpCnt == 0){
                rpOrderCntHtml.html('');
              }else{
                rpOrderCntHtml.html('<span class="badge badge-danger" style="font-size: 12px; color: rgb(255, 255, 255); vertical-align: middle; margin-bottom:-4px">'+result.data+'</span>');
              }
              */
            })
        }
        if ($(item).attr('href') == '#/order/userAuth') {
          apOrderCntHtml = $(item).find('i');
          self.$http.get('/api/select/orderNewCnt?access_token=' + token + '&ordertype=AP')
            .then((result) => {
              EventBus.$emit('changeApCnt', parseInt(result.data));
              /*
              var apCnt = parseInt(result.data);
              if(apCnt == 0){
                apOrderCntHtml.html('');
              }else{
                apOrderCntHtml.html('<span class="badge badge-danger" style="font-size: 12px; color: rgb(255, 255, 255); vertical-align: middle; margin-bottom:-4px">'+result.data+'</span>');
              }
               */
            })
        }
      });
    },

    SELECTITEMCODEOPTION({ commit }, params) {
      return new Promise((resolve, reject) => {
        var token = sessionStorage.getItem("myToken");
        var codeItemDatas = [];
        var depthXItems = [];
        var self = params[0];
        var parentCode = params[1];
        var depth = params[2];
        self.$http.get('/api/select/itemCodeList?access_token=' + token + '&parentCode=' + parentCode)
          .then((result) => {
            depthXItems = result.data;
            switch (depth) { // 몇번째 뎁스에 해당하는 코드리스트인지 파악
              case 1:
                codeItemDatas = self.$_.clone(depthXItems);
                break;
              case 2:
                codeItemDatas = self.$_.clone(depthXItems);
                break;
              case 3:
                codeItemDatas = self.$_.clone(depthXItems);
                break;
              case 4:
                codeItemDatas = self.$_.clone(depthXItems);
                break;
              default:
            }
            resolve(codeItemDatas);
          })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js